// ApoloEmblem — brasão oficial do Apolo (lira + coroa + louros), arte do Pedro.
//
// Usa os PNGs da pasta "APOLO ICONS" com troca por tema (fundo transparente):
//   dark  → emblema de traço claro  (apolo-emblem-dark.png)
//   light → emblema de traço escuro (apolo-emblem-light.png)
//
// Mesmo slot do greeting da home (h-8 w-8, à esquerda de "Boa", centralizado):
// só a arte muda — nada mais no design.

import { THEMES, useTheme } from '../../../hooks/useTheme.js';
import emblemDark from '../../../assets/apolo-emblem-dark.png';
import emblemLight from '../../../assets/apolo-emblem-light.png';

export default function ApoloEmblem({ className = '', title = 'Apolo', ...rest }) {
  const { resolved } = useTheme();
  const src = resolved === THEMES.LIGHT ? emblemLight : emblemDark;
  return <img src={src} alt={title} className={className} {...rest} />;
}
